<mat-toolbar class="small-bar">
    <span>Data</span>
    <span class="toolbar-spacer"></span>
</mat-toolbar>
<p>Coming soon from Influx db.</p>
